import {IsoDatePicker} from "./IsoDatePicker";
import React from 'react';

type IsoDateRangePickerProps = {
    value: string,
    onChange: React.EventHandler<any>
    name: string,
    className: string
}

/*

Used in the search window - value is a pair of ISO date strings separated by an underscore
e.g.  2022-09-01_2022-10-23

 */

export const IsoDateRangePicker = (props: IsoDateRangePickerProps) => {
    const changeA = (val) => {
        const value = (props.value ? props.value : '').split('_');
        const values = val.target.value + '_' + (value[1] ? value[1] : '');
        props.onChange({target: {name: props.name, value: values}, currentTarget: {name: props.name, value: values}});
    };
    const changeB = (val) => {
        const value = (props.value ? props.value : '').split('_');
        const values = (value[0] ? value[0] : '') + '_' + (val.target.value);
        props.onChange({target: {name: props.name, value: values}, currentTarget: {name: props.name, value: values}});
    };
    const values = (!props.value ? ['', ''] : props.value.split('_', 2));
    return (
        <span className={['currency-range-input',(props.className??''),"grid12"].join(' ')} style={{gridAutoRows:'unset'}}>
      <IsoDatePicker className="grid12-6" name="from" value={values[0] ? values[0] : ''} onChange={changeA} label="From"/>
      <IsoDatePicker className="grid12-6" name="to" value={values[1] ? values[1] : ''} onChange={changeB} label="To"/>
    </span>);

}
